import styles from 'components/Registration/Form/signupStyles.module.css';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RegistrationForm from './Form/RegistrationFrom';

const Hero = (props) => {
    const location = useLocation();
    const examType = useSelector(state => state.examType.examType);
    const queryParams = new URLSearchParams(location.search);

    const bannerConfig = props.banner_title
    const signupSuccessfulDetails = {
        roll_number: queryParams.get('roll_no'),
        dob: queryParams.get('dob'),
        exam_date: queryParams.get('exam_date'),
        dashboard_link: `/?roll_no=${queryParams.get(
            'roll_no',
        )}&dob=${queryParams.get('dob')}`,
    };
    return (
        <div
            className={`px-0 px-md-4 px-lg-5 ${props?.styles?.bgClass} ${styles.hero_border}`}
            id="backtop" style={{position:"relative", zIndex:"9"}}
        >
            <div
                className={` ${props?.styles?.banner_wrapper}`} 
            >
                {bannerConfig.map((bannerItem, index) => (
                    <div key={index} className={bannerItem.styles || "text-center text-md-start d-block align-content-end"}>
                        {bannerItem.webBanner &&  (
                            <div className={styles.d_block || ''}>
                                <div className={props?.styles?.desktopBanner}>
                                    <img
                                        src={bannerItem.webBanner}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </div>
                        )}

                        {bannerItem.mobBanner && (
                            <div className={`${styles.m_block} ${props?.styles?.mobileBanner}`}>
                                <img
                                    src={bannerItem.mobBanner}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        )}
                    </div>
                ))}

                <RegistrationForm
                    examType={examType}
                    initialQueryParams={queryParams}
                    signupSuccessfulDetails={signupSuccessfulDetails}
                    tncUrl={props.tncUrl}
                    privacypolicyUrl={props.privacypolicyUrl}
                    Formfooter={props.Formfooter}
                />
            </div>
        </div>
    );
};

export default Hero;